import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../atoms/button/button.component';
import { ButtonSize, ButtonSkin, ButtonType } from '../../../enums/button.enum';
import { Announcement } from '../../../models/announcement.model';
import { IconSize } from '../../../enums/icon.enum';
import { IconComponent } from '../../atoms/icon/icon.component';
import { LanguageService } from '../../../../core/services/language.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-announcement-popup-dialog',
  imports: [CommonModule, MatDialogModule, ButtonComponent, IconComponent, TranslateModule],
  templateUrl: './announcement-popup-dialog.component.html',
  styleUrl: './announcement-popup-dialog.component.scss'
})
export class AnnouncementPopupDialogComponent {
  ButtonSkin = ButtonSkin;
  ButtonSize = ButtonSize;
  ButtonType = ButtonType;
  public IconSize = IconSize;

  title: string;
  content: string;

  constructor(
    public dialogRef: MatDialogRef<AnnouncementPopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { announcement: Announcement },
    private languageService: LanguageService
  ) {
    const lang = this.languageService.getLanguage();
    const { title, content, title_hu, content_hu } = data.announcement;

    this.title = lang === 'hu' && title_hu ? title_hu : title;
    this.content = lang === 'hu' && content_hu ? content_hu : content;
  }

  close(): void {
    this.dialogRef.close(true);
  }
}
